import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  backgroundImage: string
  title: React.ReactNode
  description: React.ReactNode
  button: React.ReactNode
}

export const Product: React.FC<Props> = (props) => (
  <>
    <span
      className="imagelink imagelink--tall grid-gap3-below grid-tablet-gap2-below"
      style={{ backgroundImage: `url('${props.backgroundImage}')` }}
    />

    <div className="grid-row equalheight-group1">
      <h2 className="grid-tablet-gap1-below helper-nocase" style={{ position: 'relative' }}>
        {props.title}
      </h2>
      <p>{props.description}</p>
    </div>

    {props.button}
  </>
)

export const ProductButton: React.FC<React.ComponentProps<typeof Link>> = (props) => (
  <Link {...props} className="button" />
)
